// extracted by mini-css-extract-plugin
export var component = "TermList-module--component--I01mZ";
export var taxonomy = "TermList-module--taxonomy--3TWZu";